import { Outlet } from 'react-router-dom';
import Customization from '../MainLayout/Custmomization';

// ==============================|| MINIMAL LAYOUT ||============================== //

const MinimalLayout = () => (
    <>
        <Outlet />
        <Customization />
    </>
);

export default MinimalLayout;
